<template>
  <div>
    <el-table :data="historyData" :header-cell-style="{color:'#555'}">
      <el-table-column type="index" label="序号" width="100"></el-table-column>
      <el-table-column label="参与时间" width="200">
        <template slot-scope="scope">{{ common.timestampToTime(scope.row.create_time)}}</template>
      </el-table-column>
      <el-table-column label="分数" width="100">
        <template slot-scope="scope">{{ scope.row.is_post ? scope.row.is_examines ? scope.row.score : '待批阅' : '未提交' }}</template>
      </el-table-column>
      <el-table-column label="操作" align="right">
        <template slot-scope="scope">
          <el-button size="small" @click="viewReplay(scope.row.times)" v-if="scope.row.replay_type && !classroom_id">回顾比赛</el-button>
          <el-button size="small" @click="viewSpecialContest(scope.row.times)" v-else-if="scope.row.replay_type && classroom_id">回顾比赛</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination small @current-change="handleCurrentChange" :current-page.sync="pager.num" :page-size="pager.size" layout="total, prev, pager, next" :total="pager.total"
      :hide-on-single-page="true" style="text-align:center;margin:5px 0;">
    </el-pagination>
  </div>
</template>

<script>
import { replayHistory } from "@/api/contest";
export default {
  data() {
    return {
      historyData: [],//历史记录
      dialogTableVisible: false,
      pager: {
        size: 10,
        num: 1,
        total: 0
      },
    }
  },
  props: ['competition_id', 'classroom_id'],
  mounted() {
    this.getHistoryData();
  },
  methods: {
    getHistoryData: function () {
      let params = {
        classroom_id: this.classroom_id,
        competition_id: this.competition_id,
        pageSize: this.pager.size,
        pageNo: this.pager.num
      }
      replayHistory(params).then(response => {
        this.historyData = response.data
        this.pager.total = response.total
      })
    },
    //回顾重现赛
    viewReplay: function (times) {
      let routeData = this.$router.resolve({
        name: 'replay-index',
        params: { competitionId: this.competition_id, times: times }
      })
      window.open(routeData.href, '_blank')
    },
    //回顾专题比赛记录
    viewSpecialContest: function (times) {
      let routeData = this.$router.resolve({
        name: 'special-index',
        params: { competitionId: this.competition_id, times: times, classroomId: this.classroom_id }
      })
      window.open(routeData.href, '_blank')
    },
    handleCurrentChange: function () {
      this.getHistoryData()
    }
  },
  watch: {
    competition_id: function () {
      this.getHistoryData()
    }
  },
  filters: {
    timestampToTime: function (val) {
      return Common.timestampToTime(val);
    }

  }
}
</script>

<style>
</style>